import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import process from '../WorkEnvironmentSurveyProcess.module.css';
import classes from '../WorkEnvironmentSurveyRisk.module.css';

const TIPS = ['one', 'high', 'ripple', 'team', 'balance'] as const;

export const PlanGuideCard = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <section aria-labelledby="plan-guide-heading" className={`${process.card} ${process.sideCard}`}>
      <Heading level={2} data-size="xs" id="plan-guide-heading">
        {t('workEnvironmentPlan.guide.title')}
      </Heading>
      <ul className={classes.followUpList}>
        {TIPS.map((tip) => (
          <li key={tip} className="ds-paragraph" data-size="sm">
            {t(`workEnvironmentPlan.guide.${tip}`)}
          </li>
        ))}
      </ul>
      <Heading level={3} data-size="2xs">
        {t('workEnvironmentPlan.guide.exampleTitle')}
      </Heading>
      <Paragraph data-size="sm">{t('workEnvironmentPlan.guide.example')}</Paragraph>
    </section>
  );
};
